import React, { Component } from 'react';
import { Menu, MenuItem, Popover, Position } from '@blueprintjs/core'
import CustomLoader from './CustomLoader';
import IconMinimalButton from '../blueprintWrappers/IconMinimalButton';

/**
 * Renders: CustomLoader or navigation components using subRoutes
 * @props {Array} subRoutes
 * @props {Object} pageSaving
 * @props {Object} pageLoading
 * @props {Object} pageControls 
 * @returns CustomLoader, Popover, Menu
 */
class NavBar extends Component {
	render() {
		const { subRoutes, pageSaving, pageLoading, pageControls } = this.props;
		return <nav className = "pt-navbar navigation" key = {0}>
			<div className="pt-navbar-group pt-align-left">
				<div className="pt-navbar-heading">{process.env.REACT_APP_PROJECT_TITLE}</div>
			</div>
			{this.fullPageLoader(pageLoading, 'Loading...')}
			{this.fullPageLoader(pageSaving, 'Saving...')}
			{subRoutes.length === 0 ? null : this.subRoutes()}
			{this.mainGroup()}
			{pageControls === null ? null : this.pageControls(pageControls)}
		</nav>
	}

	fullPageLoader = (bool, text) => {
		return <CustomLoader 
			loading = { bool }
			text = { text }
			fullPage = { true }
		/>
	}
	
	mainGroup = () => {
		return <div className="pt-navbar-group pt-align-right">
			{this.mainRoutes()}
		</div>
	}

	pageControls = (pageControls) => {
		return <div className="pt-navbar-group pt-align-right">
			{pageControls}
			<span className="pt-navbar-divider"/>
		</div>
	}
	
	mainRoutes = () => {
		const { mainRoutes } = this.props;
		return mainRoutes.map(this.routeButton); 
	}
	
	subRoutes = () => {
		const { toggleSubRoute, subRoutesOpen, subRoutes } = this.props;
		return <Popover 
			className="pt-navbar-group pt-align-right pt-minimal"
			content = {this.subRouteToggleElement()}
			position = {Position['BOTTOM_RIGHT']}
			popoverClassName="pt-minimal"
			isOpen = { subRoutesOpen }
		>
			<IconMinimalButton 
				iconName = { subRoutesOpen ? 'chevron-up' : 'chevron-down' }
				onClick = { toggleSubRoute }
			/>;
		</Popover>
	}
	
	subRouteToggleElement = () => {
		const { subRoutesOpen, subRoutes } = this.props;
		return <Menu className = 'pt-dark pt-align-right pt-fixed-top'>
			{ subRoutes.map(this.subRouteItem) }
		</Menu>
	}
	
	subRouteItem = (routeObj, i) => {
		return <MenuItem 
			key = {i}
			iconName = { routeObj.icon }
			text = {routeObj.title}
		/>
	}
	
	routeButton = (routeObj, i) => {
		const { setRoute } = this.props;
		return <IconMinimalButton 
			classNameAdd = {this.routeButtonClass(routeObj)}
			iconName = { routeObj.icon }
			onClick = { setRoute(routeObj.routeName) }
			display = { routeObj.title }
			key = { i }
		/>;
	}
	
		
	routeButtonClass = (routeObj) => {
		const { currentRoute } = this.props;
		return currentRoute === routeObj.routeName ? 'navbar_selected': '';
	}
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/shared/NavBar.js